// 백업: 원본 seoMeta.js (모듈화 전)
// 문제 발생 시 이 파일로 원복 가능
import axios from 'axios'

const FALLBACK_IMAGE = 'https://cdn.daisomall.co.kr/file/CM/daisologo_1.91-1.png'

export default async function ({ store, route }) {
  if (process.client) { return }

  store.commit('seoMeta/clear')

  const path = route.path
  const query = route.query

  try {
    // 상품상세
    if (path.includes('/pd/pdr/SCR_PDR_0001') && query.pdNo) {
      const canonicalUrl = `https://www.daisomall.co.kr/pd/pdr/SCR_PDR_0001?pdNo=${query.pdNo}`
      const [{ data: res }, descResult] = await Promise.all([
        axios.post(process.env.API_BASE_URL + '/pd/pdr/pdDtl/selPdDtlInfo', { pdNo: query.pdNo }),
        axios.post(process.env.API_BASE_URL + '/pd/pdr/pdDtl/selPdDtlDesc', { pdNo: query.pdNo }).catch(() => null)
      ])
      if (res.success && res.data) {
        const pd = res.data
        const pdName = pd.exhPdNm || ''
        const brand = pd.brndNm || '다이소'
        const ctgr = pd.exhCtgr && pd.exhCtgr.length > 0 ? pd.exhCtgr[0] : null
        const categoryName = ctgr ? (ctgr.sctgrNm || ctgr.mctgrNm || ctgr.lctgrNm || '') : ''
        const price = pd.pdPrc ? `${Number(pd.pdPrc).toLocaleString()}원` : ''
        const shortDesc = [pdName, brand, categoryName, price].filter(Boolean).join(' | ')
        let description = shortDesc

        const descRes = descResult && descResult.data
        if (descRes && descRes.success && descRes.data && descRes.data.pdDtlDesc && descRes.data.pdDtlDesc.vsipPdDtl) {
          const detailText = descRes.data.pdDtlDesc.vsipPdDtl.replace(/<[^>]+>/g, '').replace(/&[^;]+;/g, ' ').replace(/\s+/g, ' ').trim()
          if (detailText) {
            description = detailText
          }
        }

        const imageUrl = pd.imgUrl ? (pd.imgUrl.startsWith('http') ? pd.imgUrl : `https://cdn.daisomall.co.kr${pd.imgUrl}`) : FALLBACK_IMAGE

        const product = {
          '@context': 'https://schema.org/',
          '@type': 'Product',
          name: pdName,
          image: imageUrl,
          description,
          sku: query.pdNo,
          brand: { '@type': 'Brand', name: brand },
          offers: {
            '@type': 'Offer',
            url: canonicalUrl,
            priceCurrency: 'KRW',
            price: pd.pdPrc,
            itemCondition: 'https://schema.org/NewCondition',
            availability: 'https://schema.org/' + (
              (pd.sleStsCd === '03' && pd.exhYn === 'Y' && pd.onldOpt && pd.onldOpt.some(opt => opt.stckQy > 0))
                ? 'InStock'
                : 'OutOfStock'
            )
          }
        }
        if (categoryName) { product.category = categoryName }
        if (pd.revwCnt > 0) {
          product.aggregateRating = { '@type': 'AggregateRating', ratingValue: pd.revwAvg, reviewCount: pd.revwCnt }
        }

        const breadcrumbItems = [{ name: '홈', url: 'https://www.daisomall.co.kr' }]
        if (ctgr) {
          if (ctgr.lctgrNm) { breadcrumbItems.push({ name: ctgr.lctgrNm, url: `https://www.daisomall.co.kr/ds/exbt/${ctgr.lctgrNo || ''}` }) }
          if (ctgr.mctgrNm) { breadcrumbItems.push({ name: ctgr.mctgrNm, url: `https://www.daisomall.co.kr/ds/exbt/${ctgr.mctgrNo || ''}` }) }
          if (ctgr.sctgrNm) { breadcrumbItems.push({ name: ctgr.sctgrNm, url: `https://www.daisomall.co.kr/ds/exbt/${ctgr.sctgrNo || ''}` }) }
        }
        breadcrumbItems.push({ name: pdName, url: canonicalUrl })
        const breadcrumb = {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbItems.map((item, i) => ({ '@type': 'ListItem', position: i + 1, name: item.name, item: item.url }))
        }

        store.commit('seoMeta/set', {
          title: shortDesc ? `${shortDesc} - 다이소몰` : '다이소몰',
          description,
          ogUrl: canonicalUrl,
          ogImage: imageUrl,
          ogType: 'product',
          canonical: canonicalUrl,
          jsonLd: [product, breadcrumb]
        })
      } else {
        store.commit('seoMeta/set', {
          title: '다이소몰',
          description: '온라인 국민가게, 다이소',
          ogUrl: canonicalUrl,
          ogImage: FALLBACK_IMAGE,
          canonical: canonicalUrl
        })
      }
    }

    if (path.includes('/ds/spexhbt/')) {
      const canonicalUrl = `https://www.daisomall.co.kr${path}`
      store.commit('seoMeta/set', {
        title: '기획전 상세 - 다이소몰',
        description: '다이소몰 기획전',
        ogUrl: canonicalUrl,
        ogImage: FALLBACK_IMAGE,
        canonical: canonicalUrl
      })
    }

    if (path.match(/^\/ds\/exbt\/[^/]+$/)) {
      const canonicalUrl = `https://www.daisomall.co.kr${path}`
      store.commit('seoMeta/set', {
        title: '기획전 - 다이소몰',
        description: '다이소몰 기획전 모아보기',
        ogUrl: canonicalUrl,
        ogImage: FALLBACK_IMAGE,
        canonical: canonicalUrl
      })
    }
  } catch (e) {
    console.error('[seoMeta middleware]', e.message)
  }
}
